<template>
  <div>
    <div>
      <x-grid
              :id="'formList'"
              :rowId="rowId"
              :pager-config="pagerConfig"
              :form-config="formConfig"
              :url="url"
              :columns="columns"
              :checkbox-config="checkboxConfig"
              :toolbar-config="toolbarConfig"
              :print-config="printConfig"
              :export-config="exportConfig"
              ref="grid"
              :cellClick="chooseRow"
              @toolbar-addData="addRow"
              @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>
          <vxe-button @click="batchDoFile()">经理部确认</vxe-button>
          <vxe-button @click="batchOpenPrint()">批量打印</vxe-button>
        </template>
        <template v-slot:operate="{row}">
            <vxe-button size="mini" status="primary" :disabled="row.isPrint1 === 1" @click="doFile(row)">经理部确认</vxe-button>
            <vxe-button size="mini" status="primary"  @click="openEdit(row)">修改</vxe-button>
            <vxe-button size="mini" status="primary"  @click="openPrint(row)">打印</vxe-button>
        </template>
      </x-grid>
    </div>

    <a-modal
            title="打印"
            centered
            :footer="null"
            :maskClosable="false"
            v-model="printModalVisible"
            :width="800"
    >
      <customerPrint  v-if="printModalVisible" :vehicleId="editRowId"  ref="customerPrint"></customerPrint>
    </a-modal>

    <a-modal
            title="批量打印"
            centered
            :footer="null"
            :maskClosable="false"
            v-model="batchPrintModalVisible"
            :width="800"
    >
      <customerBatchPrint  v-if="batchPrintModalVisible" :batchPrintData="batchPrintData"  ref="customerBatchPrint"></customerBatchPrint>
    </a-modal>

    <!-- 详情页 -->
    <formModal
            title=""
            centered
            :closable="true"
            :footer="null"
            :maskClosable="false"
            :visible="editModalVisible"
            :width="1040"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
              :rowId="editRowId"
              v-if="editModalVisible"
              ref="detailForm"
              @cancelled="closeEdit()"
              @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>

  </div>
</template>

<script>
  import XGrid from "@/components/grid/XGrid";
  import {GridMixin} from "@/utils/GridMixin";
  import {formatter as fmt} from "@/utils/ebase-formatter";
  import api from "@/services/api";
  import {loadBaseCodeData} from "@/services/baseCodeSource";
  // import {XEUtils} from "@/utils/common/FormBase";
  console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
  import {dataApi} from "@/services/client/maintainCust";
  import {mapMutations} from "vuex";
  import customerPrint from "./print";
  import customerBatchPrint from "./batchPrint";
  import detailForm from "./detail";

  async function loadBaseData() {

      this.natureOptions = await loadBaseCodeData('CD300004')//客户性质
      this.cstegoryOptions = await loadBaseCodeData('CD300003')//客户类型
      this.industryOptions = await loadBaseCodeData('CD300005')//细分行业

      let region = {
          isRegion: 1,
          isDealer: 0
      }
      let dealer = {
          isRegion: 0,
          isDealer: 1
      }
      this.regionOptions = await dataApi.selection(region);//经理部
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经理部下拉处理
      this.regionOptions = this.regionOptions.data.map(v => {
          return {
              label: v.deptName,
              value: v.deptId
          }
      })
      this.regionOptions = [{
          value: '',
          label: '全部'
      }].concat(this.regionOptions);

      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
          return {
              label: v.deptName,
              value: v.deptId
          }
      })
      this.dealerOptions = [{
          value: '',
          label: '全部'
      }].concat(this.dealerOptions);
      console.log("经销商")
      this.loadSearchOption({
          deptDealerId: this.dealerOptions,
          deptRegionId: this.regionOptions,
      })
      ////细分行业下拉代码
      this.industryOptions = this.industryOptions.map(v => {
          return {
              label: v.label,
              value: v.value
          }
      })
      this.industryOptions = [{
          value: '',
          label: '全部'
      }].concat(this.industryOptions);
      this.loadSearchOption({
          industryId: this.industryOptions,
      })

      //客户类型下拉处理
      this.cstegoryOptions = this.cstegoryOptions.map(v => {
          return {
              label: v.label,
              value: v.value
          }
      })
      this.cstegoryOptions = [{
          value: '',
          label: '全部'
      }].concat(this.cstegoryOptions);
      this.loadSearchOption({
          custCategoryId: this.cstegoryOptions,
      })

      //品系
      this.strainOptions = await dataApi.selectionStrain();//品系
      this.strainOptions = this.strainOptions.data.map(v => {
          return {
              label: v.strainName,
              value: v.strainName
          }
      })
      this.strainOptions = [{
          value: '',
          label: '全部'
      }].concat(this.strainOptions);
      this.loadSearchOption({
          strainName: this.strainOptions,
      })
  }



  const fac = XGrid.factory;

  //列表接口
  const url = api.client.MAINTAINCUST;

  //主键
  const rowId = "vehicleId";

      //列
  const columns = [
    fac.makeColumnCheckboxDefault(),
    fac.makeColumnSeqDefault(),
    fac.makeColumn({field: "modelCode", title: "车型代码", width: 140, align: 'center'}),
    fac.makeColumn("batholithNo", "底盘号", 140),
    fac.makeColumn("strainName", "品系", 100, "center"),
    fac.makeColumn("regionName", "经理部", 100, "center"),
    fac.makeColumn("dealerName", "经销商", 120, "center"),
    fac.makeColumn("e3sDeliveryDate", "销售时间", 140, "center"),
    fac.makeColumn("custName", "客户名称", 160, "center"),
    fac.makeColumn("mobile", "手机号", 100, "center",),
    fac.makeColumn("isOldFriendName", "是否乘龙老友", 160, "center",),
    fac.makeColumn({field: "sexName", title: "客户性别", width: 160, align: 'center'}),
    fac.makeColumn("birthday", "出生日期", 160, "center",),
    fac.makeColumn("nationName", "民族", 160, "center",),
    fac.makeColumn("idCard", "身份证", 160, "center",),
    fac.makeColumn("provinceName", "省份", 160, "center",),
    fac.makeColumn("cityName", "市", 160, "center",),
    fac.makeColumn("districtName", "区", 160, "center",),
    fac.makeColumn("address", "详细地址", 160, "center",),
    fac.makeColumn("custCategoryName", "客户信息类型", 160, "center",),
    fac.makeColumn("industryName", "所属细分行业", 160, "center",),
    fac.makeColumn("isPrintName", "是否已归档", 160, "center",),
    fac.makeColumn("custSourceName", "是否已同步app", 160, "center",),
    fac.makeColumn({
      title: "操作",
      field: 'operate',
      slots: {
        default: 'default'
      },
      align: 'center',
      width: 250,
      fixed: 'right'
    })
  ];
  const formConfig = fac.makeFormConfig(columns, [
      {field: "batholithNo",title: "地盘号"},//客户名称
      {field: "custName",title: "客户名称"},//客户名称
      {field: "mobile",title: '手机号'},//客户名称
      {
          field: "deptRegionId",
          // 'customSearch': true,
          title: "经理部",
          type: "select",
          options: [],
      },
      {
          field: "deptDealerId",
          // 'customSearch': true,
          title: "经销商",
          type: "search-select",
          options: [],
          placeholder:'请选择经销商',

      },
      {
          field: "isOldFriend",
          title:"是否乘龙老友",
          type: "select",
          options: [{label: '是', value: "1"}, {label: '否', value:"0"}]
      },//是否乘龙老友
      {
          field: "custCategoryId",
          title: "客户类型",
          type: "select",
          options: [],
      },
      {
        field: 'isPrint1',
        title: "是否已归档",
        type: 'select',
        options: [{label: '是', value: "1"}, {label: '否', value:"0"}]
      },
      {
        field: 'e3sDeliveryDate',
        title: "销售时间",
        type: 'dateRange',
      },//添加时间
      {
        field: 'birthday',
        customSearch: true,
        title: "生日",
        type: 'month',
      },
    {
      field: 'custSource',
      type: 'select',
      title: "是否已同步app",
      options: [{label: '是', value: "1"}, {label: '否', value:"0"}]
    }
  ]);
  //工具栏按钮

  const toolbarConfig = fac.makeToolbarConfig({
    export: true,
    import: false,
    delData: false,
    templatelSlots: "toolbarBtns",
  });

  //可编辑表格约束
  const editRules = fac.makeEditRules(columns);
  const printConfig = fac.makePrintConfig(columns);
  const pagerConfig = fac.makePagerConfig();
  const checkboxConfig = fac.makeCheckboxConfig(columns);


  export default {
    mixins: [GridMixin],
    authorize: {
      // addRow: "ADD",
      // updateRow: 'UPDATE',
      // delRow: 'DELETE',
      // importMethod:'IMPORT',
      // exportMethod:'EXPORT',
    },
    components: {
      customerPrint,
      customerBatchPrint,
      detailForm
    },
    watch: {
      $route: {
        handler: function (newValue, oldValue) {
          if (oldValue && newValue.path === '/client/maintainCustomer') {
            this.startDate = this.$store.state.setting.startTime || null
            this.endDate = this.$store.state.setting.endTime || null
            this.$nextTick(() => {
              this.refresh()
            })
          } else {
            this.setStartTime(null)
            this.setEndTime(null)
          }
        },
        immediate: true,
      },
      'formData.deptRegionId'(val) { //经理部 联动经销商

        this.formData.deptName =null
        this.getDealerData(val)
      },
    },
    computed: {
      // ...mapState("account", { currUser: "user" }),
    },
    data() {
      return {
        columns,
        rowId,
        url,
        toolbarConfig,
        printConfig,
        formConfig,
        checkboxConfig,
        editRules,
        pagerConfig,
        sexOptions:[
              { label: '女', value: '0' },
              { label: '男', value: '1' }
        ],
        natureOptions: [],
        cstegoryOptions: [],
        industryOptions:[],//细分行业
        strainOptions: [],
        regionOptions: [],
        startDate: this.$store.state.setting.startTime || null,
        endDate: this.$store.state.setting.endTime || null,
        printModalVisible:false,
        batchPrintModalVisible:false,
        editRowId:null,
        formData:null,
        batchPrintData:[]
      };
    },
    mounted() {
      this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
    },
    methods: {
      ...mapMutations('setting', ['setStartTime', 'setEndTime']),
        loadBaseData,

      openPrint(row){
        console.log("openPrint,",row);
        this.editRowId = row.vehicleId;
        this.printModalVisible = true
      },
      openEdit(row){
        console.log("openEdit,",row);
        this.editRowId = row.vehicleId;
        this.editModalVisible = true
      },
      async doFile(row){
        if (!row.vehicleId) {
          this.$message.error('经理部确认失败，数据异常');
          return false;
        }
        let vehicleIds = [row.vehicleId]
        console.log("id",vehicleIds)
        const param = {
          vehicleIds : vehicleIds
        }

        await dataApi.doFile(param).then((res) => {
          console.log("确认返回",res);
          if (res.data) {
            this.$message.success('确定成功');
          } else {
            this.$message.error('确定失败');
          }
          this.loading(false);
        }).catch(() => {
          this.loading(false);
        });
        this.refresh();
      },
      async batchDoFile(){
        let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
        if (rows.length < 1) {
          this.$message.error('请至少选择一条数据');
          return false;
        }

        this.loading(true);
        const rowsList = rows.map(item => item.vehicleId)
                .filter(vehicleId => vehicleId !== null && vehicleId !== undefined);

        const param = {
          vehicleIds : rowsList
        }

        await dataApi.doFile(param).then((res) => {
          console.log("确认返回",res);
          if (res.data) {
            this.$message.success('确定成功');
          } else {
            this.$message.error('确定失败');
          }
          this.loading(false);
        }).catch(() => {
          this.loading(false);
        });
        this.refresh();
      },

      /**
       * 经理部 经销商联动数据
       * @param id
       * @return {Promise<void>}
       */
      async getDealerData(id) {
        let dealer = {
          isRegion: 0,
          isDealer: 1,
          'filter.eq.parentId': id,
        }
        this.dealerOptions = await dataApi.selection(dealer);//经销商
        // 经销商下拉处理
        this.dealerOptions = this.dealerOptions.data.map(v => {
          return {
            label: v.deptName,
            value: v.deptId
          }
        })
        this.dealerOptions = [{
          value: '',
          label: '全部'
        }].concat(this.dealerOptions);
        console.log("联动经销商,",this.dealerOptions)
        this.loadSearchOption({
          deptDealerId: this.dealerOptions,
        })
      },
      batchOpenPrint (){
        let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
        if (rows.length < 1) {
          this.$message.error('请至少选择一条数据');
          return false;
        }
        this.loading(true);
        this.batchPrintData = rows
        this.batchPrintModalVisible = true
        this.loading(false);
      }
    },
  };
</script>

<style scoped lang="less">
  /deep/ .ant-radio-group {
    display: flex;
    width: 100%;

    .ant-radio-wrapper {
      flex: 1;
    }

    .item {
      margin: 16px 0;
    }
  }

  .showLeft {
    width: 100%;
  }
</style>

